import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type ReceivedAtEmailState = string[];

export const RECEIVED_AT_EMAIL = (
  Details: React.ComponentType<RuleTypeDetailsProps<ReceivedAtEmailState>>,
): ConditionType<ReceivedAtEmailState, ModelCondition.ReceivedAtEmail> => ({
  name: "Email Received At",
  description() {
    return "Which address the email arrived at";
  },
  Details(props: RuleTypeDetailsProps<ReceivedAtEmailState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.emails;
  },
  toModel(state) {
    return { type: ModelCondition.RECEIVED_AT_EMAIL, emails: state };
  },
  valid(state) {
    return !state.includes("No email addresses configured");
  },
});
